import { PAGE_NAVIGATION } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function callingHostPageNavigation(subject) {
  return callingAPIMethodWithQueue(PAGE_NAVIGATION, subject);
}